import { NormalStatus } from '@/constants/normal-status'

export interface Role {
  description: string;
  employeeIds: number[];
  functionIds: number[];
  id: number;
  isSystemDefault: boolean;
  menuPermissions: MenuPermission[];
  name: string;
  status: NormalStatus;
}

export interface MenuPermission {
  dataPermission?: DataPermission;
  menuId: number;
}

export enum DataPermission {
  All = 'ALL',
  Self = 'SELF',
  SelfAndSubordinates = 'SELF_AND_SUBORDINATES',
}
